import React from 'react';
import { Link } from "gatsby"

export default ({title, path}) => (
  <Link id="grid-page" to={path ? `/${path}` : '/'} style={{textDecoration: "inherit"}} >
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: "32px"}}>
        <div>{title}</div>
      </div>
  </Link>
)